import { useMemo } from 'react';

import type { ShareActionsOptions, ShareChannel } from '#src/app/shared/hooks/share';

import { useGetStarterOnboardingShareUrl } from './useGetPetitionShareUrl';
import { useGetStarterOnboardingShareContent } from './useGetStarterOnboardingShareContent';
import { useGetStarterOnboardingShareTrackingData } from './useGetStarterOnboardingShareTrackingData';

export function useStarterOnboardingShareOptions(): ShareActionsOptions<ShareChannel> {
	const getUrl = useGetStarterOnboardingShareUrl();
	const getContent = useGetStarterOnboardingShareContent();
	const getTrackingData = useGetStarterOnboardingShareTrackingData();

	return useMemo(
		() => ({
			trackingEventName: 'share_petition',
			getUrl,
			getContent,
			getTrackingData,
		}),
		[getUrl, getContent, getTrackingData],
	);
}
